var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1000 1000",
    enableBackground: "new 0 0 1000 1000",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M10,10L10,10L10,10z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M510,30C244.9,30,30,244.9,30,510s214.9,480,480,480s480-214.9,480-480S775.1,30,510,30z M392.5,708.9h-97.2V396.2h97.2V708.9z M343.3,357.8c-30.7,0-50.6-21.8-50.6-48.7c0-27.5,20.4-48.6,51.8-48.6s50.6,21.1,51.2,48.6C395.8,336.1,375.9,357.8,343.3,357.8z M747.4,708.9h-97.2V535.6c0-40.3-14.1-67.8-49.3-67.8c-26.8,0-42.8,18.6-49.9,36.4c-2.6,6.3-3.2,15.3-3.2,24.3v180.3h-97.3v-213c0-39-1.2-71.7-2.6-99.8h84.4l4.5,43.4h1.9c12.8-20.4,44.2-50.5,96.6-50.5c63.9,0,111.9,42.8,111.9,134.9V708.9L747.4,708.9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.818d9a367cb6b6e62a30e0a9014a4caa.svg";
export { ForwardRef as ReactComponent };